import React from 'react';
interface ProgressBarProps {
  current: number;
  target: number;
  className?: string;
}
export function ProgressBar({
  current,
  target,
  className = ''
}: ProgressBarProps) {
  const percentage = Math.min(current / target * 100, 100);
  return <div className={`w-full ${className}`} data-id="element-93">
      <div className="flex justify-between text-sm text-gray-600 mb-2" data-id="element-94">
        <span data-id="element-95">{current} courses</span>
        <span data-id="element-96">{target} courses</span>
      </div>
      <div className="w-full h-3 bg-gray-200 rounded-full overflow-hidden" data-id="element-97">
        <div className="h-full bg-gradient-to-r from-amber-500 to-orange-500 rounded-full transition-all duration-500 ease-out" style={{
        width: `${percentage}%`
      }} data-id="element-98" />
      </div>
    </div>;
}